import MyGroupsCertifications from "components/partial/myDesk/my-groups-certifications/my-groups-certifications";
import MyAccountLayout from "layouts/my-account/my-account-layout";
import { useRouteUserId } from "hooks/useRouteUserId";
import ProfileLayout from "layouts/private/profile/profile-layout";

const MyGroupsCertificationsPage = () => {
	const { routeUserId } = useRouteUserId();

	return routeUserId ? (
		<ProfileLayout>
			<MyGroupsCertifications />
		</ProfileLayout>
	) : (
		<MyAccountLayout>
			<MyGroupsCertifications />
		</MyAccountLayout>
	);
};

export default MyGroupsCertificationsPage;
